import { router } from "@/app/router";
import { CallRecorderProvider } from "@/features/calls/call-recorder-context";
import { initializePwa } from "@/features/pwa/pwa-runtime";
import { createQueryClient } from "@/shared/query-client";
import { ToastProvider } from "@/shared/ui/toast";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@/styles/global.css";

const queryClient = createQueryClient();

const root = document.getElementById("root");
if (!root) throw new Error("Elemento radice dell'app non trovato");

initializePwa();

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        {/* Above the routes: a recorded call survives a change of page or workspace (ADR 0067). */}
        <CallRecorderProvider>
          <RouterProvider router={router} context={{ queryClient }} />
        </CallRecorderProvider>
      </ToastProvider>
    </QueryClientProvider>
  </StrictMode>,
);
